import React from 'react';
import {
    StyledQuickFilter,
    StyledQuickFilterBorder,
    StyledQuickFont,
    StyledFilterContent,
} from '../QuickFilters.styled';
import { logErrorToConsole } from 'src/utils/util';

const QuickFilter = (props) => {
    return (
        <StyledQuickFilter
         id={`orders-quickfilter-${props.id}-filter`}
            cursor={'pointer'}
            onClick={() => {
                try {
                props.filterSwitch(props.id);
                } catch (error) {
                   logErrorToConsole(error);
                }
            }}
            isSelected={props.isFilterActive}
            showFullFilter={props.showFullFilter}
        >
            <StyledFilterContent>
                <StyledQuickFont isSelected={props.isFilterActive} isFiltername>
                    {props.label}
                </StyledQuickFont>

                <StyledQuickFont
                    isColor={props.isFilterActive ? '#140F4B' : false}
                    isFilterCount={props.count >= 0}
                >
                    {props.count}
                </StyledQuickFont>
            </StyledFilterContent>
            <StyledQuickFilterBorder isSelected={props.isFilterActive} />
        </StyledQuickFilter>
    );
};

export default QuickFilter;
